import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { FileToBeUploaded } from 'src/app/models/internal/file-tobe-uploaded';

class FileUploadSnippet {
    pending: boolean = false;
    status: string = 'init';

    constructor(public src: string, public file: File) {}
}

@Component({
    selector: 'app-image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.component.scss'],
})
export class ImageuploaderComponent implements OnInit {
    imageuploadForm = this.fb.group({
        file: [null, Validators.required],
    });
    @Input() proposalId: number;
    @Input() imageType: number; // part or package image
    @Input() OkTOUploadImages: boolean;
    @Input() isImageMissing: boolean = false;
    @Output() private imageUploaded: EventEmitter<FileToBeUploaded> =
        new EventEmitter<FileToBeUploaded>();
    @Output() private invalidImageUploaded: EventEmitter<string> =
        new EventEmitter<string>();
    @Input() isUpdateMode: boolean;

    @Input() placeholder: string;
    @Input() text: string;
    @Input() title: string;
    @Input() isImageUploaded: boolean;
    @Input() category: number;
    fileStream = '';

    selectedFile: FileUploadSnippet;
    constructor(private fb: FormBuilder) {}

    ngOnInit() {}

    triggerFileInput(fileInput: HTMLInputElement): void {
        if (this.OkTOUploadImages && !this.isImageUploaded) fileInput.click();
    }

    onFileChanged(imageInput: any) {
        const file: File = imageInput.files[0];
        const fileType = file['type'];
        const validImageTypes = [
            'image/gif',
            'image/jpeg',
            'image/jpg',
            'image/png',
            'image/jfif',
            'image/bmp',
            'image/tif',
            'image/tiff',
            'image/webp',
        ];
        if (!validImageTypes.includes(fileType)) {
            this.invalidImageUploaded.emit(
                "Invalid file type selected. Please upload documents using 'Documents' section"
            );
            return;
        }
        const reader = new FileReader();

        reader.addEventListener('load', (event: any) => {
            this.selectedFile = new FileUploadSnippet(
                event.target.result,
                file
            );
            this.fileStream = event.target.result;
            this.selectedFile.pending = true;
            const imageToBeUploaded: FileToBeUploaded = {
                File: this.fileStream,
                Type: this.imageType,
                Category: this.category,
                FileName: file.name,
                Url: this.fileStream,
            };
            this.imageUploaded.emit(imageToBeUploaded);
        });
        reader.readAsDataURL(file);
    }
}
